var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic_toggle_star_color_","transform":"translate(3.528 4.016)"},React.createElement("path",{"id":"ic_toggle_star_color_2","d":"M34.5,52.645,31.014,36.869l11.632-10.61L27.312,24.874,21.323,10l-5.99,14.874L0,26.259l11.632,10.61L8.145,52.645l13.177-8.367Z","transform":"translate(0 -10)","fill":"currentColor","stroke":"#bb3b5c","strokeWidth":"3","fillRule":"evenodd"})));
}

StarInline.defaultProps = {"width":"49.701","height":"49.863","viewBox":"0 0 49.701 49.863"};

module.exports = StarInline;

StarInline.default = StarInline;
